import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { Progress } from 'reactstrap'

class ExamTimeLeftProgressBar extends React.Component {

    isUndefined(value) {
        if (value === undefined) return true
        return false
    }

    render() {
        const { t, days, hours, minutes, percentage, text } = this.props
        return (
            <React.Fragment>
                <div className='progress-status xs-font-size'>
                    {text}
                    {this.isUndefined(days) ? '' : ` ${days}`}
                    {this.isUndefined(days) ? '' : ` ${t('study-access-days')}`}
                    {this.isUndefined(hours) ? '' : ` ${hours}`}
                    {this.isUndefined(hours) ? '' : ` ${t('study-access-hours')}`}
                    {this.isUndefined(minutes) ? '' : ` ${minutes}`}
                    {this.isUndefined(minutes) ? '' : ` ${t('study-access-minutes')}`}
                </div>
                {
                    this.isUndefined(percentage) ? '' :
                    <Progress
                        className={`custom-progress mt-0`}
                        color={'warning'}
                        value={percentage}
                    />
                }
            </React.Fragment>
        )
    }
}

ExamTimeLeftProgressBar.propTypes = {
    t: PropTypes.func,
    percentage: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    days: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    hours: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    minutes: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
}

export default withTranslation()(ExamTimeLeftProgressBar)



// WEBPACK FOOTER //
// ./src/components/UI/ExamTimeLeftProgressBar.jsx